import React, { useEffect, useState } from "react";
import { FaRegEdit } from "react-icons/fa";
import { MdOutlineDelete } from "react-icons/md";
import { useQuery } from "@tanstack/react-query";
import {
  doneSubTask,
  getProjectTask,
  incompleteSubTask,
  removeTask,
} from "../../../apiCall";
import toast from "react-hot-toast";

import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useStateValue } from "../../../StateProvider";
import { ConfirmationModal } from "../../../components/Modals/ConfirmationModal";
import { isAdmin } from "../../../utils/adminAccess";
import {
  getClassNamesOfEndDate,
  getClassNamesOfStartDate,
} from "../../../utils/colorCode";
import { formatDateTimetoAmPm, formatTimeDuration } from "../../../utils/FormateDate";

const ProjectTaskList = ({
  setIsSaveAndAddTask,
  setIsSaveAndEditeSubtask,
  setEditTaskId,
  watchedFields,
  projectStatus,
}) => {
  const [{ sysConfig, userInfo }, dispatch] = useStateValue();

  const [searchParams] = useSearchParams();
  const taskId = searchParams.get("taskId");

  // const { temId, projectId } = useParams();
  const { projectId } = useParams();

  const navigate = useNavigate();
  const location = useLocation();
  const fetchSubTask = async () => {
    // Perform the API call to fetch company info
    try {
      dispatch({ type: "SET_LOADING", status: true });

      const response = await getProjectTask(projectId);
      if (response?.status === 200) {
        console.log("GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG");
        setTaskList(response.data.data);
        setFilteredData(response.data.data);
      } else if(response?.response)  {
        toast.error(response.response.data.status);
      }
      dispatch({ type: "SET_LOADING", status: false });

      return response;
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      throw error;
    }
  };
  const deleteTask = async (id) => {
    // Perform the API call to fetch company info
    try {
      const response = await removeTask(id);
      console.log(response);
      if (response?.status === 200) {
        refetch();
        toast.success(response.data.message);
      } else if(response?.response)  {
        toast.error(response?.response?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      throw error;
    }
  };

  const {
    isLoading,
    data: subTaskListData,
    refetch,
  } = useQuery({
    queryKey: ["sub-task-temp-list"],
    queryFn: fetchSubTask,
    enabled: projectId ? true : false,
    onSuccess: (Re) => {
      console.log(Re);
    },
    onError: (e) => {
      console.log(e);
    },
  });
  const [taskList, setTaskList] = useState([]);

  // ********************************************************************* filter Data *************************************************
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredData, setFilteredData] = useState([]);
  const [currentItems, setCurrentItems] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const userFilter = searchParams.get("project_user_filter"); // Replace 'param1' with your parameter name
  const statusFilter = searchParams.get("project_status_filter");
  const searchFilter = searchParams.get("project_search_filter");
  const taskType = searchParams.get("task_type");
  const userCode = searchParams.get("user_code");

  useEffect(() => {
    filterData(searchQuery);
  }, [searchQuery]);
  useEffect(() => {
    const startIdx =
      (currentPage - 1) * Number(sysConfig["Rows in MultiLine List"]);
    const totalPageCount = Math.ceil(
      filteredData.length / Number(sysConfig["Rows in MultiLine List"])
    );
    setCurrentItems(
      filteredData.slice(
        startIdx,
        startIdx + Number(sysConfig["Rows in MultiLine List"])
      )
    );
    setTotalPages(totalPageCount);
    if (totalPageCount !== 0 && totalPageCount < currentPage) {
      setCurrentPage(totalPageCount);
    }
  }, [currentPage, filteredData, sysConfig]);

  const filterData = (query) => {
    let filtered = taskList;

    if (query) {
      filtered = filtered.filter(
        (item) =>
          item.Dscr.toLowerCase().includes(query) ||
          item.Name.toLowerCase().includes(query)
        //|| item.Mobile.includes(query)
      );
    }

    setFilteredData(filtered);
    setCurrentPage(1);
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  useEffect(() => {
    if (taskId) {
      const targetIndex = filteredData.findIndex((item) => {
        return item.ID === parseInt(taskId);
      });
      console.log(targetIndex, filteredData);
      const pageNumber =
        Math.floor(targetIndex / Number(sysConfig["Rows in MultiLine List"])) +
        1;
      console.log("page number", filteredData, targetIndex, pageNumber);
      setCurrentPage(pageNumber);
    }
  }, [taskId, filteredData]);
  const removeSelection = () => {
    if (taskId) {
      navigate(
        `${location.pathname
        }?status_filter=${statusFilter}&user_filter=${userFilter}&search_filter=${searchFilter}&task_type=${taskType ? taskType : ""
        }&user_code=${userCode ? userCode : ""}`,
        { replace: true }
      );
    }
  };
  // ************************************************************* subtask done **********************************

  const [scrollPosition, setScrollPosition] = useState(0);
  useEffect(() => {
    // Restore the scroll position after data has been fetched
    window.scrollTo(0, scrollPosition);
  }, [subTaskListData]);
  // const [staffList, setStaffList] = useState(staffListData?.status === 200 ?staffListData?.data:[]);
  // ************************************************************* Confirmation modal start **********************************

  const [confirmationShow, setConfirmationShow] = useState(false);
  const [funHandler, setFunHandler] = useState();
  const handleConfirmationClose = () => {
    setConfirmationShow(false);
  };
  const handleConfirmationShow = () => setConfirmationShow(true);

  const navigateToAddTaskWithId = (Id) => {
    if (statusFilter && userFilter) {
      navigate(
        `/update/project/${projectId}/task/${Id}?project_status_filter=${statusFilter}&project_user_filter=${userFilter}&project_search_filter=${searchFilter}`
      );
    } else if (statusFilter) {
      navigate(
        `/update/project/${projectId}/task/${Id}?project_status_filter=${statusFilter}&project_user_filter=All&project_search_filter=${searchFilter}`
      );
    } else if (userFilter) {
      navigate(
        `/update/project/${projectId}/task/${Id}?project_status_filter=All&project_user_filter=${userFilter}&project_search_filter=${searchFilter}`
      );
    } else {
      navigate(
        `/update/project/${projectId}/task/${Id}?project_status_filter=All&project_user_filter=All&project_search_filter=${searchFilter}`
      );
    }
  };
  return (
    <div className="row" key="Sd">
      <div className="col-12">
        {/* card */}
        <div className="card ">
          <div className="card-header  ">
            <div className="d-flex justify-content-end ">
              {/* <div className=" d-flex justify-content-end ">
                <div
                  className="btn btn-success me-2"
                  style={{width:"210px"}}
                  onClick={()=>startTask(taskId)}

                >
                  Start
                </div>
              </div> */}
              <div className=" d-flex justify-content-end w-100 ">
                <button
                  className="btn btn-primary col-lg-2 col-md-4 col-12 "
                  disabled={
                    projectId
                      ? !(
                        (projectStatus === "Pending" ||
                          projectStatus === "In Process") &&
                        (
                          userInfo?.user_code === watchedFields?.ProjLead ||
                          userInfo?.user_code === watchedFields?.AllocBy ||
                          isAdmin(userInfo)
                        )
                      )
                      : false
                  }
                  onClick={() => {
                    setIsSaveAndAddTask(true);
                  }}
                >
                  + Save and Add Task
                </button>
              </div>
              {/* <div className=" d-flex justify-content-end ">
                <div
                  className="btn btn-success me-2"
                  style={{width:"210px"}}
                  checked={isSubtaskDone}
                  // onClick={()=>doneTask(taskId)}
                  onClick={()=>{ handleConfirmationShow();
                    setFunHandler({
                      fun: doneTask,
                      id: taskId,
                      title: "change task status to done",
                    });}}
                >
                 Done
                </div>
              </div> */}
            </div>
          </div>
          {!isLoading ? (
            <>
              <div className="card-body">
                <div className="table-responsive table-card">
                  {currentItems.length > 0 ? (
                    <table className="table text-nowrap mb-0 responsive-table sub-table table-centered table-hover">
                      <thead className="table-light">
                        <tr>
                          <th className="ps-6">Srl</th>
                          <th className="ps-6">Task</th>
                          <th>Date</th>
                          <th>
                            By <br />
                            To
                          </th>
                          <th>Status</th>
                          {/* <th>Done</th> */}
                          <th>Approx Duration</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems.map((item, index) => (
                          <tr
                            key={`task-item-${item?.ID}-${index}`}
                            className={`${parseInt(taskId) === item?.ID
                              ? "table-primary"
                              : ""
                              }`}
                          >
                            <td
                              data-label1="Srl"

                              style={{
                                width: "50px",
                                textWrap: "wrap",
                              }}
                            >
                              {item?.OrdNo}
                            </td>
                            <td
                              // data-label1="Task"
                              className="name"

                            // style={{
                            //   maxWidth: "350px",
                            //   minWidth: "220px",
                            //   textWrap: "wrap",
                            //   textAlign: "left",
                            //   justifyContent: "left"

                            // }}
                            >
                              <div className="d-flex flex-column">

                                <strong
                                  className="cursor-pointer truncate"
                                  onClick={() => {
                                    // navigate(
                                    //   `/update/task/subtask/${item.ID}`
                                    // );
                                    if (
                                      (userInfo?.user_code === item?.TaskLead ||
                                        userInfo?.user_code === watchedFields?.ProjLead ||
                                        userInfo?.user_code === item?.AllocBy ||
                                        isAdmin(userInfo))
                                      // &&
                                      // !(
                                      //   projectStatus === "Done" ||
                                      //   projectStatus === "Cancelled" ||
                                      //   projectStatus === "Pending Review"
                                      // )

                                    ) {
                                      setEditTaskId(item.ID);
                                      navigateToAddTaskWithId(item.ID);
                                      setIsSaveAndEditeSubtask(true);
                                    }
                                  }}
                                >
                                  {item?.Name}
                                </strong>
                                {/* <br /> */}
                                <div className="truncate">
                                  <small>{item?.Dscr}</small>
                                </div>
                              </div>
                            </td>
                            <td
                              data-label1="Date"

                              style={{
                                width: "205px",
                              }}
                            >
                              <div className="d-flex flex-column">
                                <div
                                  className={getClassNamesOfEndDate(
                                    item.ActualEndDtTm,
                                    item.EndDtTm,
                                    item.Status.text
                                  )}
                                >
                                  {
                                    formatDateTimetoAmPm(item?.EndDtTm)

                                  }
                                </div>
                                <div
                                  className={getClassNamesOfStartDate(
                                    item.ActualStDtTm,
                                    item.StartDtTm,
                                    item.Status.text
                                  )}
                                >
                                  {
                                    formatDateTimetoAmPm(item?.StartDtTm)
                                  }
                                </div>
                              </div>
                              {/* <div className="bg-success text-white ps-2 pe-2 rounded"> */}
                            </td>
                            <td
                              data-label1="By"
                              data-label2="To"

                              // className="truncate"
                              style={{
                                width: "120px",
                                textWrap: "wrap",
                              }}
                            >
                              <div className="d-flex flex-column">
                                <div className="truncate-1 mb-2">
                                  <strong>{item?.AllocBy}</strong>
                                </div>
                                {/* <br /> */}
                                <div className="truncate-1">{item?.TaskLead}</div>
                              </div>
                            </td>
                            <td
                              style={{
                                width: "120px",
                                textWrap: "wrap",
                              }}
                              data-label1="Status"
                            >
                              {item?.Status?.text}
                            </td>
                            <td style={{ width: "150px" }}
                              data-label1="Approx Duration"

                            >
                              {item?.Duration === "0 days, 00:00"
                                ? "---"
                                : formatTimeDuration(item?.Duration)}
                            </td>

                            <td style={{ width: "100px" }}
                              data-label1="Action"

                            >
                              <div className="d-flex ">
                                {(
                                  userInfo?.user_code === item?.TaskLead ||
                                  userInfo?.user_code === watchedFields?.ProjLead ||
                                  userInfo?.user_code === item?.AllocBy ||
                                  isAdmin(userInfo))
                                  //  &&
                                  // !(
                                  //   projectStatus === "Done" ||
                                  //   projectStatus === "Cancelled" ||
                                  //   projectStatus === "Pending Review"
                                  // )
                                  && (
                                    <div
                                      className={`btn btn-ghost btn-icon btn-sm rounded-circle border-0 texttooltip `}
                                      data-template="editOne"
                                      onClick={() => {
                                        navigateToAddTaskWithId(item.ID);
                                        // navigate(
                                        //   `/update/task/subtask/${item.ID}`
                                        // );

                                        setEditTaskId(item.ID);
                                        setIsSaveAndEditeSubtask(true);
                                      }}
                                    >
                                      <FaRegEdit
                                        size={20}
                                        style={{ fill: "#624bff" }}
                                      />
                                      <div id="editOne" className="d-none">
                                        <span>Edit</span>
                                      </div>
                                    </div>
                                  )}

                                {(userInfo?.user_code === item?.AllocBy ||
                                  isAdmin(userInfo)) &&
                                  item?.Status?.text === "Pending" && projectStatus !== "Cancelled" && (
                                    <div
                                      className={`btn btn-ghost btn-icon btn-sm rounded-circle border-0 texttooltip `}
                                      data-template="trashOne"
                                      onClick={() => {
                                        // deleteSubTask(item?.ID)
                                        handleConfirmationShow();
                                        removeSelection();
                                        setFunHandler({
                                          fun: deleteTask,
                                          id: item?.ID,
                                          title: "delete task",
                                        });
                                      }}
                                    >
                                      <MdOutlineDelete
                                        size={22}
                                        style={{ fill: "#d2042dc7" }}
                                      />
                                      <div id="trashOne" className="d-none">
                                        <span>Delete</span>
                                      </div>
                                    </div>
                                  )}
                              </div>

                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div className="m-5 fs-3">
                      <strong>No records found.!</strong>
                    </div>
                  )}
                </div>
              </div>
              {currentItems.length > 0 && (
                <div className="card-footer d-md-flex justify-content-between align-items-center">
                  <span>
                    Showing{" "}
                    {currentPage * Number(sysConfig["Rows in MultiLine List"]) -
                      Number(sysConfig["Rows in MultiLine List"]) +
                      1}{" "}
                    to{" "}
                    {currentPage *
                      Number(sysConfig["Rows in MultiLine List"]) >=
                      filteredData.length
                      ? filteredData.length
                      : currentPage *
                      Number(sysConfig["Rows in MultiLine List"])}{" "}
                    of {filteredData.length} entries
                  </span>
                  <nav className="mt-2 mt-md-0">
                    <ul className="pagination mb-0 ">
                      <li
                        className="page-item "
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          if (currentPage > 1) {
                            handlePageChange(currentPage - 1);
                            removeSelection();
                          }
                        }}
                      >
                        <div
                          className={`page-link ${currentPage === 1 ? "disabled" : ""
                            } `}
                        >
                          Previous
                        </div>
                      </li>
                      {Array(totalPages ? totalPages : 0)
                        .fill()
                        .map((item, index) => (
                          <li
                            style={{ cursor: "pointer" }}
                            className={`${currentPage === index + 1
                              ? "page-item active"
                              : "page-item"
                              } ${currentPage + 2 >= index + 1 &&
                                index + 1 > currentPage - 2
                                ? // currentPage - 2 < index + 1
                                "d-block"
                                : "d-none"
                              }`}
                            onClick={() => {
                              handlePageChange(index + 1);
                              removeSelection();
                            }}
                          >
                            <div className="page-link">{index + 1}</div>
                          </li>
                        ))}

                      {/* <li className="page-item">
                            <a className="page-link" href="#!">
                              2
                            </a>
                          </li>
                          <li className="page-item">
                            <a className="page-link" href="#!">
                              3
                            </a>
                          </li> */}
                      <li className="page-item">
                        <div
                          style={{ cursor: "pointer" }}
                          className={`page-link ${totalPages === currentPage ? "disabled" : ""
                            } `}
                          onClick={() => {
                            if (totalPages > currentPage) {
                              handlePageChange(currentPage + 1);
                              removeSelection();
                            }
                          }}
                        >
                          Next
                        </div>
                      </li>
                    </ul>
                  </nav>
                </div>
              )}
            </>
          ) : (
            <div className="m-5 fs-3">
              <strong>Fetching records..</strong>
            </div>
          )}
        </div>
      </div>
      <ConfirmationModal
        show={confirmationShow}
        onHide={handleConfirmationClose}
        funHandler={funHandler}
      />
    </div>
  );
};

export default ProjectTaskList;
